import { render, staticRenderFns } from "./ToastificationMessageContent.vue?vue&type=template&id=0b2a4b41&scoped=true"
import script from "./ToastificationMessageContent.vue?vue&type=script&lang=js"
export * from "./ToastificationMessageContent.vue?vue&type=script&lang=js"
import style0 from "./ToastificationMessageContent.vue?vue&type=style&index=0&id=0b2a4b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2a4b41",
  null
  
)

export default component.exports